export const en = {
    "public-invitation-title": "Event invitation",
    "public-invitation-loading": "Checking your invitation",
    "public-invitation-status": "Status",
    "public-invitation-participant": "Participant",
    "public-invitation-company": "Company",
    "public-invitation-dates": "Dates",
    "public-invitation-location": "Location",
    "public-invitation-on-site-instructions": "On-site instructions",
    "public-invitation-status-submitted": "Submitted",
    "public-invitation-status-rejected": "Rejected",
    "public-invitation-status-invited": "Invited",
    "public-invitation-status-registered": "Registered",
    "public-invitation-status-confirmed": "Confirmed",
    "public-invitation-help": "Show the QR code from your email at the registration desk. Opening this page does not change your registration status.",
    "public-registration-details-title": "Registration details",
    "public-registration-details-help": "Your QR invitation arrives by email once the organizer invites you; show it at the registration desk. Opening this page does not change your registration status.",
    "public-invitation-invalid": "This invitation link is invalid or no longer active.",
    "public-invitation-unavailable": "We could not check your invitation right now.",
    "public-invitation-error-help": "Check that you opened the complete link from your email, or contact the event organizer.",
    "event-workspace.payments": "Payments",
    "event-payments.search": "Search offer, participant or payer",
    "event-payments.filter": "Offer filter",
    "event-payments.filter-current": "Current offers",
    "event-payments.filter-outstanding": "Outstanding",
    "event-payments.filter-paid": "Paid",
    "event-payments.filter-all": "All, including replaced",
    "event-payments.offer": "Offer",
    "event-payments.participant": "Participant",
    "event-payments.payer": "Payer",
    "event-payments.type": "Type",
    "event-payments.status": "Offer status",
    "event-payments.amount": "Amount",
    "event-payments.paid": "Paid",
    "event-payments.outstanding": "Outstanding",
    "event-payments.due-date": "Due date",
    "event-payments.actions": "Actions",
    "event-payments.balance-paid": "Paid",
    "event-payments.balance-partial": "Partially paid",
    "event-payments.balance-unpaid": "Unpaid",
    "event-payments.overdue": "Overdue",
    "event-payments.open-payer": "Open payer",
    "event-payments.empty": "No offers for this event yet",
    "event-payments.load-failed": "Offers and payments could not be loaded.",
    "payment-entry-title": "Record payment",
    "payment-entry-help": "Record a payment actually received. The amount is allocated to the selected offer and marked manually reconciled. Partial payments are allowed; the amount cannot exceed the remaining balance.",
    "payment-entry-offer": "Offer",
    "payment-entry-offer-total": "Offer total",
    "payment-entry-amount": "Amount received",
    "payment-entry-date": "Payment date",
    "payment-entry-method": "Payment method",
    "payment-entry-bank": "Bank transfer",
    "payment-entry-cash": "Cash",
    "payment-entry-sponsor": "Sponsor",
    "payment-entry-reference": "Payment reference",
    "payment-entry-note": "Note / confirmation basis",
    "payment-entry-save": "Save payment",
    "payment-entry-close": "Close",
    "payment-entry-required": "Required field.",
    "payment-entry-positive": "Enter an amount greater than zero.",
    "payment-entry-no-offers": "No current offers with a payable amount are available for this payer.",
    "payment-entry-failed": "Unable to save payment.",
    "payment-entry-refresh-failed": "Payment was saved, but the list could not refresh. Close this dialog and refresh the page. Do not record this payment again.",

    "hotels": "Hotels",
    "hotels-description": "Global hotel catalog",
    "hotels-field-name": "Name",
    "hotels-field-category": "Category",
    "hotels-category-select": "Select hotel category",
    "hotels-category-stars": "Hotel category: {{count}} of 5 stars",
    "hotels-category-not-selected": "Not selected",
    "hotels-field-address": "Address",
    "hotels-field-city": "City",
    "hotels-field-country": "Country",
    "hotels-field-notes": "Notes",
    "hotels-search": "Search by name, city or country",
    "hotels-new": "New hotel",
    "hotels-save": "Save",
    "hotels-delete": "Delete",
    "hotels-cancel": "Cancel",
    "hotels-saved": "Hotel saved.",
    "hotels-save-failed": "Unable to save hotel.",
    "hotels-delete-failed": "Unable to delete hotel.",
    "hotels-deleted": "Hotel deleted.",
    "hotels-delete-confirm": "Delete this hotel from the global catalog?",
    "hotels-in-use": "This hotel is linked to an event and cannot be deleted. Remove its links in event settings first.",
    "hotels-shared-info": "Changes to hotel details apply to all events using this hotel.",
    "hotels-name-required": "Enter the hotel name.",
    "hotels-not-found": "Hotel not found.",
    "hotels-retry": "Retry",
    "event-config-delete-accommodation-options-reservations-warning": "Reservations are linked to the following accommodation options: {{options}}. Deleting the options will also remove those reservations.",

    "login": "Login",
    "register": "Register",
    "username": "Username",
    "password": "Password",
    "email": "Email",
    "go-back": "Go Back",
    "EmailConfirmed_PleaseWait": "Email confirmed. Please wait...",
    "EmailConfirmationErrorPage_Title": "Email Confirmation Error",
    "EmailConfirmationErrorPage_Text": "There was an error during email confirmation. Please try again.",
    "EmailConfirmed_Success": "Email successfully confirmed.",
    "The Username field is required.": "The Username field is required.",
    "The Email field is required.": "The Email field is required.",
    "The Password field is required.": "The Password field is required.",
    "EmailConfirmationErrorPage_BackButton": "Go Back",
    "redirector.unknownRoleForUsingApp": "You do not yet have access assigned to the application.",
    "NotFoundPage_Title": "Page Not Found",
    "NotFoundPage_BackButton": "Go Back",
    "NotFoundPage_Text": "The page you are looking for was not found.",
    "ConfirmYourEmail": "A confirmation link has been sent to your email. Please confirm your email.",
    "User email not confirmed": "Email not confirmed",
    "EmailNotConfirmed": "Email not confirmed",
    "ResendConfirmationEmail": "Resend confirmation link",
    "ResendConfirmationEmail_Success": "Confirmation link successfully sent.",
    "PasswordTooShort": "Password is too short.",
    "User not found": "User not found.",
    "back": "Back",
    "home": "Home",
    "logout": "Logout",
    "users": "Users",
    "users-description": "Overview of Users",
    "organization-members": "Organization members",
    "organization-members-description": "Manage organizer accounts",
    "organization-member": "Organization member",
    "add-organization-member": "Add member",
    "resend-onboarding": "Resend onboarding",
    "pending-onboarding": "Pending",
    "organization-member-created": "Organization member created",
    "organization-member-onboarding-sent": "Onboarding email sent",
    "organization-member-onboarding-invalid": "This onboarding link is invalid or expired.",
    "organization-member-onboarding-invalid-title": "Onboarding link cannot be used",
    "organization-member-onboarding-title": "Set up organizer account",
    "organization-member-onboarding-help": "Choose your password to confirm the invitation.",
    "organization-member-onboarding-submit": "Set password",
    "administrator-only-page": "This page is available to administrators only.",
    "administration": "Administration",
    "error-loading-items": "Error loading items",
    "search": "Search",
    "clear-filter": "Clear filter",
    "change-type": "Change Type",
    "created-by": "Created by",
    "created-between": "Created between",
    "state": "State",
    "created": "Created",
    "changes": "Changes",
    "Previous": "Previous",
    "Next": "Next",
    "create": "Add",
    "cancel": "Cancel",
    "save": "Save",
    "id": "ID",
    "emailConfirmed": "Email Confirmed",
    "are-you-sure-you-want-to-delete-this-item": "Are you sure you want to delete this item?",
    "delete-confirmation-title": "Confirm deletion",
    "delete-confirmation-named-target": "The {{itemType}} \"{{itemName}}\" will be deleted.",
    "delete-confirmation-count-target": "Selected records to delete ({{itemType}}): {{count}}.",
    "delete-confirmation-target": "The {{itemType}} will be deleted.",
    "delete-confirmation-question": "Are you sure you want to delete it?",
    "delete-target-record": "record",
    "delete-target-participant": "participant",
    "delete-target-payer": "payer",
    "delete-target-hotel": "hotel",
    "delete-target-invitation": "pending invitation",
    "delete-target-template-field": "template field",
    "delete-target-file": "file",
    "delete-target-accommodation-option": "accommodation option",
    "delete-target-event-access": "event access",
    "delete": "Delete",
    "page": "Page",
    "code": "Code",
    "InvalidEmail": "Enter a valid email",
    "additional": "Additional",
    "resendConfirmationEmail": "Resend email confirmation link",
    "no-items": "No items",
    "status": "Status",
    "date": "Date",
    "roles": "Roles",
    "Admin": "Admin",
    "Customer": "Customer",
    "taxId": "Tax ID",
    "actions": "Actions",
    "locations": "Locations",
    "address": "Address",
    "location-name": "Location Name",
    "geodecode-address": "Search Address on Map",
    "import-locations": "Import Locations",
    "adding-users": "Adding Users",
    "notification": "Notification",
    "successfully-deleted-item": "Item successfully deleted",
    "successfully-deleted-item-with-id": "Item successfully deleted with ID",
    "error-deleting-item-with-id": "Error deleting item with ID",
    "successfully-duplicated-item-with-id": "Item successfully duplicated with ID",
    "error-duplicating-item-with-id": "Error duplicating item with ID",
    "company": "Company",
    "linkedin-url": "LinkedIn URL",
    "InvalidUserName": "Enter a valid username",
    "editing-users": "Editing Users",
    "edit": "Edit",
    "show-only-unassigned": "Show only unassigned",
    "settings": "Settings",
    "global-settings": "Global settings",
    "start-search": "Start Search",
    "isMainLocation": "Main Location",
    "assign": "Assign",
    "assigned-user": "Assigned to User",
    "details": "Details",
    "user": "User",
    "user-overview": "User Overview",
    "MANAGER": "Manager",
    "user-details": "User Details",
    "confirmationEmailSent": "Confirmation Email Sent",
    "userName": "Username",
    "firstName": "First Name",
    "lastName": "Last Name",
    "system": "System",
    "basic-data": "Basic Data",
    "role": "Role",
    "languages-full:hr": "Croatian",
    "languages-full:en": "English",
    "languages-full:de": "German",
    "languages-full:it": "Italian",
    "duplicate": "Duplicate",
    "name": "Name",
    "name-hr": "Name (Croatian)",
    "name-en": "Name (English)",
    "place": "Place",
    "description": "Description",
    "event-information": "Event information",
    "event-information-hr": "Event information (Croatian)",
    "event-information-en": "Event information (English)",
    "on-site-registration-instructions": "On-site registration instructions",
    "on-site-registration-instructions-hr": "On-site registration instructions (Croatian)",
    "on-site-registration-instructions-en": "On-site registration instructions (English)",
    "nameAndDescription": "Name and Description",
    "NoResults": "No Results",
    "dateTime": "Date and Time",
    "initiatingUser": "Initiator",
    "deactivated": "Deactivated",
    "parent": "Parent",
    "parentId": "Parent",
    "Email already exists": "Email already exists",
    "unassigned": "Unassigned",
    "note": "Note",
    "first-page": "First Page",
    "next-page": "Next Page",
    "previous-page": "Previous Page",
    "last-page": "Last Page",
    "yes": "Yes",
    "no": "No",
    "warning": "Warning",
    "phoneNumber": "Phone Number",
    "preferredLanguage": "Preferred Language",
    "enums:COMPLETED": "Completed",
    "enums:CANCELLED": "Cancelled",
    "quantity": "Quantity",
    "add-row": "Add Row",
    "header": "Header",
    "basics": "Basics",
    "priority": "Priority",
    "BackGoToLogin": "Back to Login",
    "close": "Close",
    "notes": "Notes",
    "createdAt": "Creation Date and Time",
    "error-occurred": "An error occurred",
    "reload": "Reload",
    "user-updated-successfully": "User Successfully Updated",
    "profile-updated": "Profile Updated",
    "profile": "Profile",
    "developer-feedback-title": "Report a problem",
    "developer-feedback-help": "Describe what happened. Your name and email will be included for the development team.",
    "developer-feedback-description": "Problem description",
    "developer-feedback-placeholder": "What were you trying to do, and what happened?",
    "developer-feedback-send": "Send report",
    "developer-feedback-queued": "Your report was received and is waiting to be sent.",
    "developer-feedback-error": "Your report could not be sent right now. Please try again.",
    "about-app-title": "About the app",
    "app-shell.open-menu": "Open menu",
    "app-shell.close-menu": "Close menu",
    "app-shell.home": "ATIventura home",
    "app-shell.main-navigation": "Main navigation",
    "app-shell.breadcrumb": "Breadcrumb",
    "app-shell.language": "Language",
    "app-shell.account-menu": "Account menu",
    "about-app-description": "EventFlow helps organizers prepare events, manage participant registrations, and work on site.",
    "about-app-version": "Version",
    "about-app-changelog": "What's new",
    "about-app-error": "Version information is currently unavailable.",
    "profile-error": "Profile is currently unavailable.",
    "profile-load-error-title": "Profile unavailable",
    "profile-save-success": "Profile saved.",
    "save-profile": "Save profile",
    "email-signature": "Email signature",
    "location": "Location",
    "requested-by": "Requested By",
    "startDate": "Start Date",
    "endDate": "End Date",
    "count": "Count",
    "xlsx_export": "Export to Excel",
    "csv_export": "Export to CSV",
    "current-page": "Page",
    "page-of": "of",
    "value": "Value",
    "Login": "Login",
    "change-password": "Change Password",
    "oldPassword": "Old Password",
    "newPassword": "New Password",
    "password-changed": "Password Changed",
    "password-reset": "Password Reset",
    "password-reset-successful": "Password Reset Successful",
    "no-data": "No Data",
    "events-and-forms": "Events & registration setup",
    "attendees-and-registrations": "Attendees & registrations",
    "finance": "Finance",
    "resources": "Resources",
    "events": "Events",
    "events-description": "Create and manage events, schedules, and published access codes.",
    "archive": "Archive",
    "archive-description": "Review archived events and operational history.",
    "payers": "Payers",
    "payers-description": "Search and edit the global payer catalog.",
    "fee-type-public-hidden": "Hidden on public form",
    "fee-type-requires-proof": "Requires proof",
    "participant-type-proof": "Participant proof",
    "participant-delete-confirm": "Delete participant?",
    "participant-delete-confirm-description": "Participant {{participant}} will be removed from the event.",
    "participant-delete-success": "Participant deleted.",
    "participant-delete-failed": "Participant could not be deleted.",
    "participant-register-missing-payer": "Payer",
    "participant-register-active-form-required": "Before registering a participant, create and activate a public registration form in the event's Form tab.",
    "open-payer": "Open payer",
    "new-payer": "New payer",
    "save-registration": "Save registration",
    "select-payer": "Select payer",
    "select-payer-placeholder": "Search by name, email, or tax ID",
    "event-config": "Event setup",
    "event-config-description": "Configure branding, taxes, pricing, options, hotels, and participant email copy.",
    "registration-forms": "Public registration",
    "registration-forms-description": "Share the live public registration URL for each event.",
    "accommodations": "Accommodations",
    "accommodations-description": "Manage accommodation options tied to your events.",
    "room-allotments": "Room allotments",
    "room-allotments-description": "Allocate room blocks and track availability over event nights.",
    "participants": "Participants",
    "participants-description": "View and manage the people attending your events.",
    "registrations": "Registrations",
    "registrations-description": "Review attendee registrations, statuses, and assigned accommodations.",
    "notifications": "Notifications",
    "notifications-description": "Send event email notifications and review delivery history.",
    "general-settings": "Organization settings",
    "general-settings-description": "Manage payee and default tax settings.",
    "public-event-forms": "Share live registration",
    "public-event-forms-description": "Share the hosted public registration URL and iframe. Setup changes appear there immediately.",
    "public-event-forms.explainer-title": "What the public form uses",
    "public-event-forms.explainer-active": "The hosted URL always uses the current event setup.",
    "public-event-forms.explainer-live-setup": "Pricing, payment methods, accommodation, room availability, activities, and public copy stay live from setup.",
    "public-registration-share": "Public registration sharing",
    "public-registration-share-description": "Use the hosted URL for a plain WordPress link, or copy the iframe snippet for an allowlisted embed.",
    "recipient-email": "Recipient email",
    "sent-by": "Sent by",
    "sent-at": "Sent at",
    "failed-at": "Failed at",
    "failure-message": "Failure message",
    "notification-history-count": "{{count}} delivery records",
    "notifications-recipient-details-search": "Search recipients",
    "notifications-recipient-details-search-placeholder": "Search by email, status, or delivery",
    "notifications-recipient-details-search-count": "{{shown}} of {{total}} recipients",
    "notifications-recipient-details-search-empty": "No recipients match the search.",
    "notifications-save-recipient-selection": "Save selection",
    "notifications-reply-to-enabled": "Use a Reply-To address",
    "notifications-reply-to-addresses": "Reply-To addresses",
    "notifications-reply-to-placeholder": "Enter Reply-To addresses",
    "customer-purchase-order": "Customer purchase order",
    "download-customer-purchase-order": "Download purchase order",
    "customer-purchase-order-missing": "Missing",
    "replace-customer-purchase-order": "Replace purchase order",
    "upload-customer-purchase-order": "Upload purchase order",
    "customer-purchase-order-upload-success": "Customer purchase order saved.",
    "customer-purchase-order-upload-failed": "Customer purchase order could not be saved.",
    "customer-purchase-order-download-failed": "Customer purchase order could not be downloaded.",
    "select-event-to-view-notifications": "Select an event to view notification history.",
    "notification-status:SENT": "Sent",
    "notification-status:FAILED": "Failed",
    "notification-status:DRAFT": "Draft",
    "cta.new-event": "New event",
    "cta.view-schedule": "View schedule",
    "cta.view-registrations": "Registrations",
    "cta.view-rooming": "Rooming",
    "cta.view-forms": "Forms",
    "cta.preview-form": "Preview form",
    "cta.new-accommodation": "New accommodation",
    "cta.manage-room-types": "Manage room types",
    "cta.new-room-allotment": "New room allotment",
    "cta.adjust-allotment": "Adjust allotment",
    "cta.new-participant": "Add participant",
    "cta.import-participants": "Import participants",
    "cta.new-registration": "Add registration",
    "cta.assign-accommodation": "Assign accommodation",
    "cta.view-public-form": "Open public form",
    "cta.copy-public-link": "Copy public link",
    "cta.save": "Save",
    "cta.edit-definition": "Edit definition",
    "start-date": "Start date",
    "end-date": "End date",
    "capacity": "Capacity",
    "beds": "Beds",
    "rooms": "Rooms",
    "assigned": "Assigned",
    "remaining": "Remaining",
    "total-rooms": "Total rooms",
    "version": "Version",
    "fields": "Fields",
    "event": "Event",
    "participant": "Participant",
    "group": "Group",
    "members": "Members",
    "balance": "Balance",
    "payer": "Payer",
    "reference": "Reference",
    "payment": "Payment",
    "target": "Target",
    "amount": "Amount",
    "timestamp": "Timestamp",
    "action": "Action",
    "entity": "Entity",
    "linked-to": "Linked to",
    "filters": "Filters",
    "filter.event": "Event",
    "event-drilldown": "Start from an event",
    "event-workspace.navigation": "Event workspace navigation",
    "event-workspace.group.setup": "Setup",
    "event-workspace.group.operations": "Operations",
    "event-workspace.overview": "Overview",
    "event-workspace.group-operate": "Operate",
    "event-workspace.group-setup": "Set up",
    "event-workspace.group-selector": "Event workspace area",
    "event-workspace.settings": "Event basics",
    "event-workspace.registration-fees": "Fees and payment",
    "event-workspace.accommodation": "Accommodation",
    "event-workspace.activities": "Activities",
    "event-workspace.registration-form": "Form",
    "event-workspace.rooming": "Reservations",
    "event-workspace.audit": "Audit",
    "event-workspace.workspace": "Event workspace",
    "event-workspace.current-workflow": "Current workflow",
    "event-workspace.current-group": "Current group",
    "event-workspace.current-section": "Current section",
    "event-workspace.status-labels": "Event status labels",
    "event-workspace.form-linked": "Form linked",
    "event-workspace.form-needed": "Form needed",
    "event-workspace.active-group": "Active",
    "event-overview.setup-pipeline": "Setup review",
    "event-overview.setup-pipeline-description": "Review the setup sequence: event basics, fees/payment, accommodation, activities/add-ons, and the registration form.",
    "event-overview.open-event-basics": "Open event basics",
    "event-overview.trend-group-by": "Group by",
    "event-overview.trend-period": "Period",
    "event-overview.trend-days": "Days",
    "event-overview.trend-weeks": "Weeks",
    "event-overview.trend-months": "Months",
    "event-overview.trend-last-7-days": "Last 7 days",
    "event-overview.trend-last-30-days": "Last 30 days",
    "event-overview.trend-last-6-months": "Last 6 months",
    "setup-sequence.basic-title": "Event basics",
    "setup-sequence.basic-description": "Set event identity, dates, Croatian and English public content, visuals/documents, tax values, payment methods, and email copy before sharing the form.",
    "setup-sequence.pricing-title": "Fees",
    "setup-sequence.pricing-description": "The participation-fee flag and payment methods stay in Event settings. Use this page for pricing periods, participant fee types, and prices.",
    "setup-sequence.accommodation-title": "Accommodation",
    "setup-sequence.accommodation-description": "Optional setup for hotels, room types, room allotments, prices, and payment deadlines. Public registration consumes event room inventory before payment.",
    "event-config-hotel-unavailable": "Hotel unavailable",
    "event-config-room-type-unavailable": "Room type unavailable",
    "setup-sequence.activities-title": "Activities/add-ons",
    "setup-sequence.registration-title": "Registration form",
    "has-participation-fee": "Has participation fee",
    "method": "Method",
    "paid-at": "Paid at",
    "packageCode": "Package code",
    "upload-file": "Upload file",
    "clear": "Clear",
    "file-not-selected": "No file selected",
    "file-uploaded": "File uploaded",
    "logo-url": "Event logo file",
    "program-pdf-url": "Program PDF file",
    "venue-layout-image-url": "Venue map image file",
    "sponsors-image-url": "Sponsor image file",
    "primary-color": "Primary color",
    "secondary-color": "Secondary color",
    "badge-template-url": "Badge artwork file",
    "certificate-template-url": "Certificate template file",
    "certificate-name-x": "Name placement - horizontal offset",
    "certificate-name-y": "Name placement - vertical offset",
    "validation.color-required": "{{field}} is required.",
    "validation.hex-color": "{{field}} must be a HEX color like #223F6B.",
    "validation.field-required": "{{field}} is required.",
    "validation.required-field": "Required field",
    "validation.number": "{{field}} must be a number.",
    "asset-mode-combined-pdf": "One PDF",
    "asset-mode-separate-program-layout": "Program + map",
    "public-asset-mode": "Public asset mode",
    "combined-program-layout-pdf-url": "Program and venue PDF file",
    "price-period-start-date-required": "Start date is required.",
    "price-period-end-date-required": "End date is required.",
    "price-period-end-before-start": "End date must be on or after start date.",
    "price-period-overlap": "Pricing periods cannot overlap. This range overlaps with {{period}} ({{startDate}} - {{endDate}}).",
    "event-end-date-before-start": "End date must be on or after start date.",
    "event-access-card-title": "Event access",
    "event-access-user-placeholder": "Organizer",
    "event-access-grant": "Grant access",
    "event-access-revoke": "Revoke",
    "event-access-empty": "No collaborators",
    "event-access-granted": "Event access granted",
    "event-access-revoked": "Event access revoked",
    "privacy-consent-missing": "Missing",
    "privacy-consent-recorded": "Recorded",
    "privacy-consent-version": "Version",
    "privacy-consent-event-id": "Consent event ID",
    "organizerName": "Organizer",
    "sponsorName": "Sponsor",
    "event-create-wizard.title": "New event",
    "event-create-wizard.basic-description": "Create the event shell now. Finish public copy, visuals, prices, stay, and activities from the workspace.",
    "event-create-wizard.event-name": "Event name",
    "event-create-wizard.place": "City / place",
    "event-create-wizard.address": "Venue address",
    "event-create-wizard.end-date-after-start": "End date must be on or after start date.",
    "event-create-wizard.fee-choice": "Registration fee",
    "event-create-wizard.fee-no": "No fee",
    "event-create-wizard.fee-yes": "Fee event",
    "event-create-wizard.no-fee-description": "No fee selected. No price matrix is needed for first save.",
    "event-create-wizard.fee-description": "Fee selected. Add periods, participant types, and prices after creation.",
    "event-create-wizard.create-and-open": "Create event",
    "event-create-wizard.created": "Event created",
    "event-create-wizard.missing-event-id": "Event was created, but the new workspace could not be identified.",
    "error-deleting-item": "Unable to delete item",
    "list-search": "List search",
    "event-workspace.invalid-event": "Invalid event",
    "check-in.token-url-invalid": "Scanned URL does not contain a registration code token.",
    "check-in.badge-download-missing": "Scan an eligible code first.",
    "check-in.badge-download-failed": "Badge could not be generated.",
    "check-in.badge-downloaded": "Print-ready badge downloaded.",
    "country": "Country",
    "registration": "Registration",
    "check-in.download-badge": "Download badge",
    "price": "Price",
    "event-basic-setup-saved": "Event setup saved",
    "event-payment-method-required": "Enable at least one payment method for each category.",
    "event-payment-methods-saved": "Payment methods saved",
    "hotel": "Hotel",
    "room-type": "Room type",
    "price-per-night": "Price per night",
    "period": "Period",
    "payment-deadline": "Payment deadline",
    "event-required": "Select an event",
    "name-required": "Name is required.",
    "start-date-required": "Start date is required.",
    "end-date-required": "End date is required.",
    "registration-vat": "Participation and activity VAT",
    "registration-vat-required": "Registration VAT is required.",
    "accommodation-ppo": "Accommodation PPO",
    "accommodation-ppo-required": "Accommodation PPO is required.",
    "payment-methods": "Payment methods",
    "save-payment-methods": "Save payment methods",
    "payment-method-bank-transfer": "Bank transfer",
    "payment-method-pos": "POS",
    "pricing-periods": "Pricing periods",
    "question-type": "Question type",
    "template": "Template",
    "language": "Language",
    "city": "City",
    "room-reservation-released": "Room reservation released.",
    "room-reservation-release-failed": "Could not release room reservation.",
    "release-room-reservation-confirm-title": "Release this room reservation?",
    "release": "Release",
    "select-event-to-view-rooming-list": "Select an event to view rooming details.",
    "download-rooming-csv": "Download rooming CSV",
    "no-rooming-registrations-found": "No accommodation reservations found for this event.",
    "no-event-selected": "No event selected.",
    "event-workspace.not-found": "Event not found.",
    "event-workspace.load-error": "Event workspace unavailable",
    "event-workspace.open": "Open",
    "reservations": "Reservations",
    "date-range": "Date range",
    "archived-at": "Archived at",
    "archived-event": "Archived event",
    "general-settings-saved": "General settings saved",
    "not-authorized": "Not authorized",
    "company-payee-name": "Company/payee name",
    "payee-name-required": "Company/payee name is required.",
    "oib": "OIB",
    "payee-oib-required": "OIB is required.",
    "payee-address": "Payee address",
    "payee-address-required": "Payee address is required.",
    "iban": "IBAN",
    "payee-iban-required": "IBAN is required.",
    "registration-vat-default": "Default participation VAT",
    "accommodation-ppo-default": "Default accommodation PPO",
    "phone": "Phone",
    "inactive": "Inactive",
    "organization-member-created-email-failed": "Organization member created, but onboarding email failed. Check SMTP settings and resend onboarding.",
    "organization-member-onboarding-email-failed": "Onboarding email failed. Check SMTP settings and resend onboarding.",
    "organization-member-updated": "Organization member updated",
    "organization-member-reactivate-confirm": "Reactivate this organization member?",
    "organization-member-deactivate-confirm": "Deactivate this organization member?",
    "confirm": "Confirm",
    "organization-member-reactivated": "Organization member reactivated",
    "organization-member-deactivated": "Organization member deactivated",
    "organization-member-invite-removed": "Pending invite removed",
    "organization-member-remove-invite": "Remove invite",
    "deactivate": "Deactivate",
    "reactivate": "Reactivate",
    "edit-organization-member": "Edit member",
    "participant-detail": "Participant detail",
    "export": "Export",
    "participant-export-minimal-fields": "Event ID, email, status, payment, certificate",
    "participant-export-history": "Participant CSV export history",
    "select-event-to-view-participant-export-history": "Select an event to view participant export history.",
    "error.download-failed": "Download failed",
    "certificate-generated": "Certificate ready",
    "certificate-generation-failed": "Certificate could not be generated",
    "download": "Download",
    "participation-offer": "Participation offer",
    "accommodation-offer": "Accommodation offer",
    "accommodation": "Accommodation",
    "due-date": "Due date",
    "certificates": "certificates",
    "generate": "Generate",
    "room": "Room",
    "dates": "Dates",
    "nights": "nights",
    "registration-code": "Registration code",
    "revoked": "Revoked",
    "issued": "Issued",
    "certificate": "Certificate",
    "history": "History",
    "requested": "Requested",
    "generated": "Generated",
    "emailed": "Emailed",
    "resend": "Resend",
    "rooming": "Rooming",
    "registration-codes": "Registration codes",
    "no-registration-codes": "No registration codes",
    "certificate-history": "Certificate history",
    "no-certificates": "No certificates",
    "room-reservations": "Room reservations",
    "offer-resend-failed": "Offer email could not be sent",
    "clipboard-unavailable": "Clipboard is unavailable",
    "cta.copied": "Copied",
    "public-registration-hosted-url": "Hosted registration URL",
    "public-registration-iframe-snippet": "Iframe embed snippet",
    "rooming-csv": "Rooming CSV",
    "rooming-export-minimal-fields": "Accommodation-only export",
    "rooming-export-history": "Rooming CSV export history",
    "select-event-to-view-rooming-export-history": "Select an event to view rooming export history.",
    "new-password": "New password",
    "new-password-required": "New password is required.",
    "new-password-min-length": "Use at least {{count}} characters.",
    "confirm-new-password": "Confirm new password",
    "confirm-new-password-required": "Confirm the new password.",
    "passwords-do-not-match": "Passwords do not match.",
    "forgot-password": "Forgot password?",
    "organizer-password-recovery": "Organizer password recovery",
    "organizer-password-recovery-help": "Use your organizer email address to reset your password. Administrators cannot assign or view organizer passwords.",
    "organizer-email": "Organizer email",
    "organizer-email-required": "Organizer email is required.",
    "validation.complete-required-fields": "Check the required fields and try again.",
    "validation.correct-invalid-values": "Check the entered values and try again.",
    "subject": "Subject",
    "ok": "OK",
    "last-name": "Last name",
    "payer-save-success": "Payer saved.",
    "payer-create-success": "Payer added.",
    "payer-save-failed": "The payer could not be saved.",
    "payer-delete-success": "Payer deleted.",
    "payer-delete-failed": "The payer could not be deleted.",
    "offer": "Offer",
    "participant-and-event": "Participant / event",
    "payer-search-placeholder": "Search by name, email or OIB",
    "payer-edit": "Edit payer",
    "payer-create": "Add payer",
    "all-payers": "All payers",
    "no-stored-offers": "No saved offers",
    "enums:EN": "English",
    "enums:HR": "Croatian",
    "enums:QUEUED": "Queued",
    "enums:POS": "POS",
    "change-payer": "Change payer",
    "participant-payer-chosen-at-registration": "The payer is chosen when the participant is registered.",
    "participant-payer-locked": "An offer was already issued to this payer, so the payer cannot be changed.",
    "participant-payer-required": "Select a payer first.",
    "participant-payer-change-success": "Payer changed.",
    "participant-payer-change-failed": "The payer could not be changed.",
    "organizer-registration.title": "Register participant",
    "organizer-registration.submit": "Register",
    "organizer-registration.payer-mode-new": "New payer",
    "organizer-registration.payer-mode-existing": "Existing payer",
    "organizer-registration.payer-required": "Select a payer.",
    "organizer-registration.verification-note": "The participant receives an email to confirm the address. The offer is sent after confirmation, the same as for public registration.",
    "organizer-registration.success": "The participant is registered. An email to confirm the address has been sent.",
    "organizer-registration.unavailable": "Registration is not possible: the event is completed or has no active registration form.",
    "organizer-registration.load-failed": "The registration form could not be loaded.",
    "qr-email-not-confirmed": "The participant has not confirmed the email address yet",
    "enums:PRIJAVLJEN": "Applied",
    "enums:ODBIJEN": "Rejected",
    "enums:POZVAN": "Invited",
    "enums:REGISTRIRAN": "Checked in",
    "enums:POTVRDEN": "Confirmed",
    "validation-required": "Required field",
    "validation-invalid-email": "Enter a valid email address.",
    "validation-invalid-phone": "Enter a valid phone number.",
    "validation-invalid-linkedin": "Enter a LinkedIn profile URL.",
    "event-config-delete-accommodation-options-none": "Select at least one room type to delete.",
    "template-event-data-unavailable": "Event data is not loaded yet, so the template cannot be saved. Reload the page and try again.",
    "notifications-send-reason-event": "Open an event first.",
    "notifications-send-reason-recipients": "Select at least one recipient.",
    "notifications-send-reason-channel": "Select a channel.",
    "notifications-send-reason-content": "Write the message content.",
    "notifications-send-reason-subject": "Enter the email subject.",
    "notifications-send-reason-reply-to": "Enter a reply-to address or turn reply-to off."
}
